import {useTranslation} from "next-i18next";
import {Filter, FilterAnyLabels} from "../../data/Filter/Filter.config";

interface PersonenSelectPropsInterface {
	personCount?: number;
	onChangePersonCount: (personCount: number) => void;
	onSubmit: () => void;
	isVermietungMainFilter?: boolean;
}

export default function PersonenSelect(props: PersonenSelectPropsInterface) {
	const {t} = useTranslation();
	return (
		<label className={`space-y-2 ${props.isVermietungMainFilter ? "" : "h-20"} col-span-1 w-[60%] md:w-auto pl-1 md:pl-0`}>
      <span className="text-[16px] md:text-[20px] whitespace-nowrap">
        {t("components.personenSelect.personCount")}:
      </span>
			<input
				type="number"
				min={0}
				value={
					props.personCount && props.personCount > 0 ? props.personCount : ""
				}
				onKeyUp={(event) => {
					// If the user presses the "Enter" key on the keyboard
					if (event.key === "Enter") {
						props.onSubmit();
					}
				}}
				onChange={(e) => props.onChangePersonCount(parseInt(e.target.value))}
				className=" w-full p-2 h-[40px] m-0 border-none input-field placeholder:text-[12px] md:placeholder:text-[16px] input-show-arrows"
				placeholder={t(FilterAnyLabels.BELIEBIG)}
			/>
		</label>
	);
}
